/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import * as React from 'react';
import { RouteParam, RouteId } from '../../../router/routes';
import { UiType } from '../../../data/api/auth/authClient.typings';
import { TurnoversTableData } from './TurnoverConfig';
import { Table, TableBody, TableHead, TableRow } from '@mui/material';

//TODO use permits and get rid of this configs
export const CASH_BOX_CARD_ROUTE_BY_UI_TYPE: { [key in UiType]?: RouteId } = {
    [UiType.Inspector]: RouteId.RegistryCashboxCard,
    [UiType.RegionInspector]: RouteId.RegistryCashboxCard,
    [UiType.CentralInspector]: RouteId.RegistryCashboxCard,
    [UiType.Operator]: RouteId.RegistryCashboxCard,
    [UiType.Taxpayer]: RouteId.RegistryCashboxCard,
};

export const DEVICE_CARD_ROUTE_BY_UI_TYPE: { [key in UiType]?: RouteId } = {
    [UiType.Inspector]: RouteId.RegistryDeviceCard,
    [UiType.Operator]: RouteId.RegistryDeviceCard,
};

//note that there are different documents cards here
export const DOCUMENT_CARD_ROUTE_BY_UI_TYPE: { [key in UiType]?: RouteId } = {
    [UiType.Inspector]: RouteId.RegistryDocumentCard,
    [UiType.RegionInspector]: RouteId.RegistryDocumentCardPict,
    [UiType.CentralInspector]: RouteId.RegistryDocumentCardPict,
    [UiType.Taxpayer]: RouteId.RegistryDocumentCardPict,
};

export const CASHBOX_LIST_ROUTE_BY_UI_TYPE: { [key in UiType]?: RouteId } = {
    [UiType.Inspector]: RouteId.RegistryCashboxesList,
    [UiType.RegionInspector]: RouteId.RegistryCashboxesList,
    [UiType.CentralInspector]: RouteId.RegistryCashboxesList,
    [UiType.Taxpayer]: RouteId.RegistryCashboxesList,
    [UiType.Operator]: RouteId.RegistryCashboxesList,
};

export interface ListTableLinkData<T extends object> {
    routeId?: RouteId;
    routeParamName: RouteParam;
    routeParamKeyForValue: keyof T;
}

export interface ListTableColumnConfig<T extends object> {
    keyForValue: keyof T;
    translatePath: string;
    isHidden?: boolean;
    isSearchable?: boolean;
    isSortable?: boolean;
    link?: ListTableLinkData<T>;
    isBold?: boolean;
    isClickable?: boolean;
    isWithTooltip?: boolean;
    displayAsColorBar?: boolean;
    displayAsColorText?: boolean;
    displayCustomCell?: boolean;
    displayCustomHeader?: boolean;
    align?: 'right' | 'left' | 'center';
    minWidth?: number;
    maxWidth?: number;
    width?: number | string;
}

export type TurnoversColumnConfig = Pick<
    ListTableColumnConfig<TurnoversTableData>,
    | 'keyForValue'
    | 'translatePath'
    | 'isHidden'
    | 'link'
    | 'isBold'
    | 'isWithTooltip'
    | 'align'
    | 'minWidth'
    | 'maxWidth'
    | 'width'
>;

export enum TurnoverReportType {
    ByPeriod = 'RegistryScreens.byPeriods',
    ByObject = 'RegistryScreens.byObjects',
    ByCashBox = 'RegistryScreens.byCashboxes',
}

export interface Incapacitated {
    incapacitated: boolean;
}

export const getVirtuosoTableComponents = (isUnfoldedLess: boolean) => {
    return {
        Table: (props: object) => (
            <Table {...props} style={{ borderCollapse: 'separate' }} size={isUnfoldedLess ? 'small' : 'medium'} />
        ),
        TableHead: React.forwardRef<HTMLTableSectionElement>((props, ref) => <TableHead {...props} ref={ref} />),
        TableRow: (props: object) => <TableRow {...props} hover />,
        TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => <TableBody {...props} ref={ref} />),
    };
};
